module.exports = __webpack_public_path__ + "img/footer-logo.c805842d.png";